import { isDefined } from "@dhx/ts-common/core";
import { EventSystem, IEventSystem } from "@dhx/ts-common/events";
import { Id } from "@dhx/ts-common/types";
import { DataCollection } from "@dhx/ts-data";
import { DataEvents, SelectionEvents } from "../types";

interface ISelectionEventsHandlersMap {
	[key: string]: (...args: any[]) => any;
	[SelectionEvents.afterSelect]: (id: Id, subId?: Id | undefined) => void;
	[SelectionEvents.afterUnSelect]: (id: Id, subId?: Id | undefined) => void;
	[SelectionEvents.beforeSelect]: (id: Id, subId?: Id | undefined) => void | boolean;
	[SelectionEvents.beforeUnSelect]: (id: Id, subId?: Id | undefined) => void | boolean;
}

export class Selection {
	public events: IEventSystem<SelectionEvents, ISelectionEventsHandlersMap>;
	private _data: DataCollection;

	private _selected: Id = null;
	private _subSelected: Id = null;

	constructor(_config: any, data?: DataCollection, events?: IEventSystem<any>) {
		this.events = events || new EventSystem();
		this._data = data;

		this._data.events.on(DataEvents.removeAll, () => {
			this._selected = null;
			this._subSelected = null;
		});
	}
	getId(): Id {
		return this._selected;
	}
	getSubId(): Id {
		return this._subSelected;
	}
	getItem(): any {
		if (this._selected) {
			return this._data.getItem(this._selected);
		}
		return null;
	}
	remove(id?: Id, subId?: Id): boolean {
		id = id || this._selected;
		subId = subId || this._subSelected;

		if (!id) {
			return true;
		}
		if (this.events.fire(SelectionEvents.beforeUnSelect, [id, subId])) {
			this._selected = null;
			this._subSelected = null;

			const item = this._data.getItem(id);

			if (subId && item.$item.getBaseType() === "line") {
				const titles = item?.title?.text?.map(title => {
					if (title.id === subId) {
						return {
							...title,
							$selected: false,
						};
					}
					return title;
				});
				this._data.update(
					id,
					{
						title: {
							...item.title,
							text: titles,
						},
						$selected: false,
						$subSelected: null,
					},
					true
				);
			} else {
				this._data.update(id, { $selected: false }, true);
			}

			this.events.fire(SelectionEvents.afterUnSelect, [id, subId]);
			return true;
		}
		return false;
	}
	add(id: Id, subId?: Id): void {
		if (!this._data.exists(id)) {
			return;
		}
		const item = this._data.getItem(id);

		if (item.type === "$sgroup") {
			id = item.$group;
		}
		if (
			(this._selected === id && !isDefined(subId) && !isDefined(this._subSelected)) ||
			(this._selected === id && this._subSelected === subId)
		) {
			return;
		}
		this.remove();

		if (this.events.fire(SelectionEvents.beforeSelect, [id, subId])) {
			this._selected = id;

			if (subId && item.$item.getBaseType() === "line") {
				this._subSelected = subId;

				const titles = item.title.text.map(title => {
					if (title.id === subId) {
						return {
							...title,
							$selected: true,
						};
					}
					return title;
				});
				this._data.update(
					id,
					{
						title: {
							...item.title,
							text: titles,
						},
						$selected: true,
						$subSelected: subId,
					},
					true
				);
			} else {
				this._data.update(id, { $selected: true }, true);
			}

			this.events.fire(SelectionEvents.afterSelect, [id, subId]);
		}
	}
}
